export class FeatureProperty {
    private data_type: string;
    private display_name: string;
    private system_name: string;
    constructor(jsonObj: any) {
        this.data_type = jsonObj.data_type;
        this.display_name = jsonObj.display_name;
        this.system_name = jsonObj.system_name;
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/application/feature_property.model.ts